<div class="agenda-fundo">
<!-- Acima dos modais internos da Agenda: a senha já foi chamada e o paciente está a caminho. -->
<div class="aviso-senha" *ngIf="avisoSenha" role="alert">
  <svg class="i" viewBox="0 0 24 24"><path d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2a2 2 0 0 1-.6 1.4L4 17h5m6 0a3 3 0 1 1-6 0m6 0H9" /></svg>
  <span>Senha <b>{{ avisoSenha }}</b> chamada para você</span>
  <button type="button" class="btn btn-primario btn-sm" (click)="irParaAtendimento()">Ir para o atendimento</button>
  <button type="button" class="btn-ico" title="Continuar na Agenda" (click)="avisoSenha = null">
    <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
  </button>
</div>
<div class="agenda-pg" role="dialog" aria-label="Agenda">
  <div class="agenda-cab">
    <h2>
      <svg class="i" viewBox="0 0 24 24"><rect x="3" y="4.5" width="18" height="16" rx="2.5" /><path d="M3 9.5h18M8 2.5v4M16 2.5v4" /></svg>
      Agenda
    </h2>
    <div class="chamada-auto" *ngIf="chamadaAutomatica as c" role="status">
      <span class="ponto"></span>{{ c.texto }}
      <button type="button" class="btn btn-contorno btn-sm" *ngIf="c.podePausar" (click)="pausarChamada.emit()"
        title="Pausar a chamada automática">Pausar</button>
    </div>
    <button type="button" class="btn-ico" title="Fechar a Agenda" (click)="fechar.emit()">
      <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
    </button>
  </div>

  <div class="pagina">
    <div class="layout" [class.recolhido]="filtrosRecolhidos">
      <!-- Filtros em cascata -->
      <aside class="card filtros" aria-label="Filtros da agenda" [class.recolhido]="filtrosRecolhidos">
        <button
          *ngIf="filtrosRecolhidos"
          type="button"
          class="btn-ico abrir-filtros"
          title="Mostrar os filtros"
          aria-label="Mostrar os filtros"
          [attr.aria-expanded]="false"
          (click)="alternarFiltros()"
        >
          <svg class="i" viewBox="0 0 24 24"><path d="M3 5h18l-7 8v6l-4 2v-8z" /></svg>
        </button>
        <ng-container *ngIf="!filtrosRecolhidos">
        <h2>
          <svg class="i sm" viewBox="0 0 24 24"><path d="M3 5h18l-7 8v6l-4 2v-8z" /></svg>
          Filtros
          <button
            type="button"
            class="btn-ico recolher"
            title="Recolher os filtros"
            aria-label="Recolher os filtros"
            [attr.aria-expanded]="true"
            (click)="alternarFiltros()"
          >
            <svg class="i sm" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></svg>
          </button>
        </h2>

        <div class="campo">
          <span class="rot">Tipo de agenda</span>
          <div class="seg" [class.seg-4]="tipos.length === 4" role="group" aria-label="Tipo de agenda">
            <button
              *ngFor="let t of tipos"
              type="button"
              [class.ativo]="f.tipo === t.valor"
              [attr.aria-pressed]="f.tipo === t.valor"
              (click)="escolherTipo(t.valor)"
            >{{ t.rotulo }}</button>
          </div>
          <p class="dica" *ngIf="ehIntegrado">Consulta e exame do mesmo médico na mesma grade.</p>
        </div>

        <div class="campo">
          <label for="fUn">Unidade</label>
          <select
            id="fUn"
            [ngModel]="f.cdEstabelecimento"
            (ngModelChange)="trocarEstabelecimento($event)"
            [disabled]="carregando.estabelecimentos || !estabelecimentos.length"
          >
            <option [ngValue]="null">{{ carregando.estabelecimentos ? 'Carregando...' : 'Selecione...' }}</option>
            <option *ngFor="let e of estabelecimentos" [ngValue]="e.cdEstabelecimento">
              {{ e.nmEstabelecimento || e.sigla || e.cdEstabelecimento }}
            </option>
          </select>
        </div>

        <div class="campo" *ngIf="mostraEspecialidade">
          <label for="fEsp">Especialidade</label>
          <select
            id="fEsp"
            [ngModel]="f.cdEspecialidade"
            (ngModelChange)="trocarEspecialidade($event)"
            [disabled]="!f.cdEstabelecimento || carregando.especialidades"
          >
            <option [ngValue]="null">
              {{ !f.cdEstabelecimento ? 'Selecione a unidade...' : carregando.especialidades ? 'Carregando...' : 'Todas' }}
            </option>
            <option *ngFor="let e of especialidades" [ngValue]="e.codigo">{{ e.descricao }}</option>
          </select>
        </div>

        <div class="campo" *ngIf="ehIntegrado">
          <label for="fMed">Médico</label>
          <select
            id="fMed"
            [ngModel]="f.cdMedico"
            (ngModelChange)="trocarMedico($event)"
            [disabled]="!f.cdEstabelecimento || carregando.medicos || !medicos.length"
          >
            <option [ngValue]="null">
              {{ !f.cdEstabelecimento ? 'Selecione a unidade...' : carregando.medicos ? 'Carregando...' : 'Selecione o médico...' }}
            </option>
            <option *ngFor="let m of medicos" [ngValue]="m.cdMedico">{{ m.nmMedico }}</option>
          </select>
          <p class="dica" *ngIf="f.cdEstabelecimento && !carregando.medicos && !medicos.length">
            Nenhum médico com consulta e exame nesta unidade.
          </p>
        </div>

        <div class="campo" *ngIf="!ehIntegrado">
          <label for="fAg">Agenda</label>
          <select
            id="fAg"
            [ngModel]="f.cdAgenda"
            (ngModelChange)="trocarAgenda($event)"
            [disabled]="!f.cdEstabelecimento || carregando.agendas"
          >
            <option [ngValue]="null">
              {{ !f.cdEstabelecimento ? 'Selecione a unidade...' : carregando.agendas ? 'Carregando...' : 'Selecione...' }}
            </option>
            <option *ngFor="let a of agendas" [ngValue]="a.cdAgenda">{{ a.dsAgenda }}</option>
          </select>
        </div>

        <div class="campo">
          <label for="fCls">Classificação</label>
          <select id="fCls" [ngModel]="f.ieClassifAgenda" (ngModelChange)="trocarClassificacao($event)">
            <option [ngValue]="null">Todas</option>
            <option *ngFor="let c of opcoesClassif" [ngValue]="c.rotulo">{{ c.rotulo }}</option>
          </select>
        </div>

        <div class="checks">
          <label><input type="checkbox" [ngModel]="f.cancelados" (ngModelChange)="marcarCancelados($event)" />Exibir cancelados</label>
          <label><input type="checkbox" [ngModel]="f.soAgendados" (ngModelChange)="marcarSoAgendados($event)" />Somente agendados</label>
          <label><input type="checkbox" [ngModel]="f.soLivres" (ngModelChange)="marcarSoLivres($event)" />Somente livres</label>
        </div>

        <div class="linha-btn">
          <button type="button" class="btn btn-primario btn-sm" style="flex: 1" [disabled]="!pronto" (click)="filtrar()">Filtrar</button>
          <button type="button" class="btn btn-contorno btn-sm" (click)="limpar()">Limpar</button>
        </div>
        <p class="dica">A grade carrega sozinha quando a agenda (ou o médico, no Integrado) é escolhida.</p>
        </ng-container>
      </aside>

      <section class="conteudo">
        <div class="card">
          <div class="barra">
            <div class="seg-vis" role="group" aria-label="Visão da agenda">
              <button type="button" data-visao="dia" [class.ativo]="visao === 'dia'" [attr.aria-pressed]="visao === 'dia'" (click)="mudarVisao('dia')">
                <svg class="i sm" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2.5" /><path d="M3 9h18M3 15h18M9 3v18" /></svg>Dia
              </button>
              <button type="button" data-visao="mes" [class.ativo]="visao === 'mes'" [attr.aria-pressed]="visao === 'mes'" (click)="mudarVisao('mes')">
                <svg class="i sm" viewBox="0 0 24 24"><rect x="3" y="4.5" width="18" height="16" rx="2.5" /><path d="M3 9.5h18M8 2.5v4M16 2.5v4" /></svg>Mês
              </button>
              <button type="button" data-visao="agendas" [class.ativo]="visao === 'agendas'" [attr.aria-pressed]="visao === 'agendas'" (click)="mudarVisao('agendas')">
                <svg class="i sm" viewBox="0 0 24 24"><path d="M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01" /></svg>Agendas do Dia
              </button>
            </div>

            <div class="nav-data" *ngIf="visao !== 'mes'">
              <button type="button" class="btn-ico" title="Dia anterior" (click)="diaAnterior()">
                <svg class="i" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></svg>
              </button>
              <input type="date" aria-label="Data" [ngModel]="f.data" (ngModelChange)="trocarData($event)" />
              <button type="button" class="btn-ico" title="Dia seguinte" (click)="diaSeguinte()">
                <svg class="i" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6" /></svg>
              </button>
              <button type="button" class="btn btn-contorno btn-sm" (click)="hoje()">Hoje</button>
              <span class="rotulo-data">{{ rotuloData }}</span>
            </div>

            <div class="nav-data" *ngIf="visao === 'mes'">
              <button type="button" class="btn-ico" title="Mês anterior" (click)="mesAnterior()">
                <svg class="i" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6" /></svg>
              </button>
              <span class="rotulo-data" style="text-transform: capitalize">{{ rotuloMesAtual }}</span>
              <button type="button" class="btn-ico" title="Mês seguinte" (click)="mesSeguinte()">
                <svg class="i" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6" /></svg>
              </button>
            </div>

            <button type="button" class="btn btn-disp btn-sm" title="Vagas em todas as unidades da marca" (click)="abrirDisponibilidade()">
              <svg class="i sm" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5M11 8v6M8 11h6" /></svg>
              Encontrar Disponibilidade
            </button>

            <button
              *ngIf="visao === 'dia'"
              type="button"
              class="btn btn-contorno btn-sm btn-fila-medica"
              [disabled]="!filaMedicaBarra.pode"
              [title]="filaMedicaBarra.pode ? 'Chegadas de hoje nesta agenda' : filaMedicaBarra.motivo"
              (click)="abrirFilaMedicaDaBarra()"
            >
              <svg class="i sm" viewBox="0 0 24 24"><circle cx="9" cy="7" r="3" /><path d="M3 20a6 6 0 0 1 12 0M16 4h5M16 9h5M18 14h3" /></svg>
              Fila médica
            </button>

            <span class="espaco"></span>
            <div class="chips" *ngIf="visao !== 'agendas'">
              <span *ngFor="let c of chips" class="chip-f" [class.fixo]="!c.removivel">
                {{ c.rotulo }}
                <button *ngIf="c.removivel" type="button" title="Remover filtro" (click)="removerChip(c.chave)">
                  <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
                </button>
              </span>
            </div>
          </div>
        </div>

        <div class="alerta bad" *ngIf="erro" role="alert">
          <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
          <div>{{ erro }}</div>
          <button type="button" class="btn-ico fechar" title="Fechar" (click)="erro = ''">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
          </button>
        </div>

        <div class="alerta ok" *ngIf="sucesso" role="status">
          <svg class="i sm" viewBox="0 0 24 24"><path d="m5 12 5 5 9-10" /></svg>
          <div>{{ sucesso }}</div>
          <button type="button" class="btn-ico fechar" title="Fechar" (click)="sucesso = ''">
            <svg class="i sm" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
          </button>
        </div>

        <app-agenda-grade
          *ngIf="visao === 'dia'"
          [filtro]="filtroAplicado()"
          [contexto]="contexto()"
          [dica]="dica"
          [classificacoes]="classificacoes"
          (irParaData)="trocarData($event)"
          (novoAgendamento)="aoNovoAgendamento($event)"
          (encaixe)="aoEncaixe()"
          (acao)="aoAcaoGrade($event)"
          (menuLinha)="abrirMenuLinha($event)"
          (rolagemGrade)="fecharMenu()"
        ></app-agenda-grade>

        <app-agendas-do-dia
          *ngIf="visao === 'agendas'"
          [cdEstabelecimento]="unidadeAgendasDoDia"
          [data]="f.data"
          [nomeUnidade]="nomeUnidadeAgendasDoDia"
          (abrirAgenda)="abrirDaListaDoDia($event)"
        ></app-agendas-do-dia>

        <!-- Visão mensal: calendário 6x7, status do dia; clicar no dia abre a grade naquela data. -->
        <div class="card vazio" *ngIf="visao === 'mes' && !mesPronto">
          <b>Escolha a agenda</b>
          A visão mensal exige a agenda, ou o médico no Integrado.
        </div>

        <div class="card" *ngIf="visao === 'mes' && mesPronto">
          <div class="mes-cab">
            <span class="sub2" *ngIf="!carregandoMes">{{ filtroAplicado()?.agenda?.dsAgenda || (ehIntegrado ? 'Consulta e exame deste médico' : '') }}</span>
            <span class="espaco"></span>
            <button type="button" class="btn-ico" title="Atualizar" (click)="carregarMes()" [disabled]="carregandoMes">
              <svg class="i" viewBox="0 0 24 24"><path d="M20 11a8 8 0 0 0-14.6-4.5L4 8M4 4v4h4M4 13a8 8 0 0 0 14.6 4.5L20 16M20 20v-4h-4" /></svg>
            </button>
          </div>

          <div class="alerta bad" *ngIf="erroMes" role="alert">
            <div>{{ erroMes }}</div>
          </div>

          <div class="cal" *ngIf="!erroMes" [class.carregando]="carregandoMes">
            <div class="dow" *ngFor="let d of ['dom','seg','ter','qua','qui','sex','sáb']">{{ d }}</div>
            <button
              type="button"
              class="dia"
              *ngFor="let c of celulas"
              [class.fora]="c.foraDoMes"
              [class.hoje]="c.hoje"
              [ngClass]="'st-' + c.status"
              [disabled]="c.status === 'sem' || carregandoMes"
              (click)="abrirDiaDoMes(c.data)"
            >
              <span class="num">{{ c.numeroDia }}</span>
              <span class="st">{{ c.rotuloStatus }}</span>
              <span class="tol" *ngIf="c.dia">
                T {{ c.dia.total }} · O {{ c.dia.ocupados }} · L {{ c.dia.livres }}
                <ng-container *ngIf="c.dia.limiteRetornos !== null && c.dia.limiteRetornos < 999"> · Ret {{ c.dia.retornos }}/{{ c.dia.limiteRetornos }}</ng-container>
              </span>
              <span class="barra-oc"><i [style.width.%]="c.percentualOcupacao"></i></span>
            </button>
          </div>

          <div class="leg-mes" *ngIf="!erroMes">
            <span class="st-disp"><i></i>Disponível</span>
            <span class="st-parc"><i></i>Bloqueio parcial</span>
            <span class="st-bloq"><i></i>Bloqueado</span>
            <span class="st-lot"><i></i>Lotado</span>
            <span class="st-sem"><i></i>Sem regra</span>
          </div>
        </div>
      </section>
    </div>
  </div>

  <!-- Antes do agendamento: o modal do horário escolhido abre por cima da busca. -->
  <app-agenda-disponibilidade
    *ngIf="modalDisponibilidade"
    [contexto]="contexto()"
    [coberto]="!!modalAgendamento"
    (fechar)="fecharDisponibilidade()"
    (agendar)="aoAgendarHorario($event)"
  ></app-agenda-disponibilidade>

  <app-agenda-agendamento
    *ngIf="modalAgendamento && (modalAgendamento.filtro || filtroAplicado())"
    [modo]="modalAgendamento.modo"
    [linha]="modalAgendamento.linha"
    [filtro]="(modalAgendamento.filtro || filtroAplicado())!"
    [exameInicial]="modalAgendamento.exame ?? null"
    [pacienteInicial]="modalAgendamento.paciente ?? null"
    [contexto]="contexto()"
    [classificacoes]="classificacoes"
    (fechar)="fecharModais()"
    (salvo)="aoSalvarModal($event)"
  ></app-agenda-agendamento>

  <app-agenda-reserva
    *ngIf="modalReserva"
    [linha]="modalReserva"
    (fechar)="fecharModais()"
    (salvo)="aoSalvarModal($event)"
  ></app-agenda-reserva>

  <app-agenda-transferir
    *ngIf="modalTransferir"
    [linhas]="modalTransferir"
    [contexto]="contexto()"
    (fechar)="fecharModais()"
    (salvo)="aoSalvarModal($event)"
  ></app-agenda-transferir>

  <app-agenda-alterar
    *ngIf="modalAlterar"
    [linhas]="modalAlterar"
    [contexto]="contexto()"
    [classificacoes]="classificacoes"
    [cdEstabelecimento]="filtroAplicado()?.cdEstabelecimento ?? null"
    [cdEspecialidadeFiltro]="filtroAplicado()?.cdEspecialidade ?? null"
    (fechar)="fecharModais()"
    (concluido)="aoConcluirLote()"
  ></app-agenda-alterar>

  <app-agenda-cancelar
    *ngIf="modalCancelar"
    [linhas]="modalCancelar"
    (fechar)="fecharModais()"
    (concluido)="aoConcluirLote()"
  ></app-agenda-cancelar>

  <app-agenda-trocar-paciente
    *ngIf="modalTrocarPaciente"
    [linha]="modalTrocarPaciente"
    (fechar)="fecharModais()"
    (salvo)="aoSalvarModal($event)"
  ></app-agenda-trocar-paciente>

  <app-agenda-desvincular
    *ngIf="modalDesvincular"
    [linha]="modalDesvincular"
    (fechar)="fecharModais()"
    (salvo)="aoSalvarModal($event)"
  ></app-agenda-desvincular>

  <!-- Menu ⋮ ou botão direito da linha -->
  <div class="menu-fundo" *ngIf="menu" (click)="fecharMenu()">
    <div class="menu" [style.top.px]="menu.top" [style.left.px]="menu.left" (click)="$event.stopPropagation()">
      <div class="cab-menu" *ngIf="menu.alvo.length > 1">{{ menu.alvo.length }} selecionados</div>
      <button
        *ngFor="let it of itensMenu.principais"
        type="button"
        class="mi"
        [class.perigo]="it.perigo"
        [disabled]="it.desabilitado"
        [title]="it.motivo || ''"
        (click)="clicarItemMenu(it)"
      >{{ it.rotulo }}<small *ngIf="it.motivo || it.dica">{{ it.motivo || it.dica }}</small></button>
      <hr *ngIf="itensMenu.principais.length && itensMenu.fila.length" />
      <div class="cab-menu" *ngIf="itensMenu.fila.length">Já existe na Fila</div>
      <button
        *ngFor="let it of itensMenu.fila"
        type="button"
        class="mi"
        [disabled]="it.desabilitado"
        [title]="it.motivo || ''"
        (click)="clicarItemMenu(it)"
      >{{ it.rotulo }}<small *ngIf="it.motivo">{{ it.motivo }}</small></button>
    </div>
  </div>
</div>
</div>
